// extracted by mini-css-extract-plugin
module.exports = {"resultList":"SearchResultsList-module--result-list--1UVlU","resultItem":"SearchResultsList-module--result-item--3jEgD"};